import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Y from '../../../y18n'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'
import ProductsDropdown from '../../../common/dropdowns/products-dropdown'
import SubscriptionPacksDropdown from '../../../common/dropdowns/subscription-packs-dropdown'

import products, * as productActions from '../../../store/products'
import * as subscriptionPackActions from '../../../store/subscription-packs'
import Styles from '../../../common/styles'


const mapStateToProps = state => ({
  products: state.products,
  subscriptionPacks: state.subscriptionPacks
})

const mapDispatchToProps = dispatch => ({
  productActions: bindActionCreators(productActions, dispatch),
  subscriptionPackActions: bindActionCreators(subscriptionPackActions, dispatch)
})

class NewProductDialog extends Component {
  switchToggled = name => (e, checked) => {
    this.props.productActions.updateActive(name, checked)
  }

  inputChanged = name => e => {
    this.props.productActions.updateActive(name, e.target.value)
  }

  submitForm (e, product) {
    e.preventDefault()
    let productRequest = {
      name: product.name,
      ean: product.ean,
      country: product.country,
      subscriptionPack: {
        id: product.subscriptionPack.id,
        name: product.subscriptionPack.name
      },
      suggestedRefillProductId: product.suggestedRefillProductId,
      uri: product.uri
    }

    if(product.dataActive === true)
      productRequest.dataMb = product.dataMb

    if(product.smsActive === true)
      productRequest.sms = product.sms

    if(product.days > 0)
      productRequest.days = product.days

    this.props.productActions.createProduct(productRequest)
  }

  editSubpack = (e) => {
    let selection = this.props.subscriptionPacks.items.filter(subpack => subpack.id === e.target.value)
    if(selection && selection.length === 1){
      const subpack = {
        id: selection[0].id,
        name: selection[0].name
      }

      this.props.productActions.clearActiveSubscriptionPack()
      this.props.productActions.setActiveSubscriptionPack(subpack)
    }
  }

  render () {
    const { classes, products, productActions, subscriptionPacks } = this.props
    if (!products.active || !products.new) return null
    return (
      <div>
        <Dialog
          open={products.active !== null}
          onClose={() => productActions.resetNew()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitForm(e, products.active)}>
            <DialogTitle>{Y`Add product`}</DialogTitle>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Name`}
                type='text'
                value={products.active.name}
                onChange={this.inputChanged('name')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
              <TextField
                margin='normal'
                label={Y`EAN`}
                type='text'
                value={products.active.ean}
                onChange={this.inputChanged('ean')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
              <TextField
                margin='normal'
                label={Y`URL`}
                type='text'
                value={products.active.uri}
                onChange={this.inputChanged('uri')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
              <CountriesDropdown
                handleChange={this.inputChanged('country')}
                value={products.active.country}
                required={true}
              />
            </DialogContent>
            <DialogContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      classes={{
                        checked: classes.checked
                      }}
                      checked={products.active.dataActive}
                      onChange={this.switchToggled('dataActive')}
                      aria-label={Y`Data active`}
                      color='primary'
                    />
                  }
                  label={Y`Data`}
                />
                {products.active.dataActive ? (
                  <DialogContent>
                    <div className={classes.flexRow}>
                      <TextField
                        margin='normal'
                        label={Y`Data (MB)`}
                        type='number'
                        value={products.active.dataMb}
                        onChange={this.inputChanged('dataMb')}
                        className={classes.flexItemLeft}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: classes.root,
                            input: classes.input
                          }
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.formLabel
                        }}
                      />
                      <TextField
                        margin='normal'
                        label={Y`Days`}
                        type='number'
                        value={products.active.days}
                        onChange={this.inputChanged('days')}
                        className={classes.flexItemRight}
                        InputProps={{
                          disableUnderline: true,
                          classes: {
                            root: classes.root,
                            input: classes.input
                          }
                        }}
                        InputLabelProps={{
                          shrink: true,
                          className: classes.formLabel
                        }}
                      />
                    </div>
                  </DialogContent>
                ) : (
                  ''
                )}
              </FormGroup>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      classes={{
                        checked: classes.checked
                      }}
                      checked={products.active.smsActive}
                      onChange={this.switchToggled('smsActive')}
                      aria-label={Y`SMS active`}
                      color='primary'
                    />
                  }
                  label={Y`SMS`}
                />
                {products.active.smsActive ? (
                  <DialogContent>
                    <TextField
                      margin='normal'
                      label={Y`SMS`}
                      type='number'
                      value={products.active.sms}
                      onChange={this.inputChanged('sms')}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.root,
                          input: classes.input
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.formLabel
                      }}
                      fullWidth
                    />
                  </DialogContent>
                ) : (
                  ''
                )}

                <SubscriptionPacksDropdown
                  value={products.active.subscriptionPack ? products.active.subscriptionPack.name : (subscriptionPacks.active ? subscriptionPacks.active.name : "")}
                  label={Y`subscription_pack`}
                  handleChange={this.editSubpack}
                  inputProps={{
                    active: !products.active.subscriptionPack ? null : products.active.subscriptionPack
                  }}
                  fullWidth={true}
                  required={true}
              />
              </FormGroup>
              <FormGroup>
                <ProductsDropdown
                  handleChange={this.inputChanged('suggestedRefillProductId')}
                  value={products.active.suggestedRefillProductId || ''}
                  country={products.active.country}
                />
              </FormGroup>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => productActions.resetNew()}
              >{Y`Cancel`}</Button>
              <Button
                type='submit'
                variant='raised'
                color='primary'
                style={{ color: '#fff' }}
              >
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

NewProductDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewProductDialog)
export default withStyles(Styles)(NewProductDialog)



// WEBPACK FOOTER //
// ./src/pages/products/containers/new-product-dialog.js